import { ApplicationInsights } from "@microsoft/applicationinsights-web";

// Same App Insights resource already linked to the backend (appi-madinetmasr-gym), so
// frontend page views and backend API calls show up correlated in one place. The
// connection string isn't a secret here — the client SDK is designed to ship this value
// to the browser, since that's literally how it sends telemetry in the first place.
const CONNECTION_STRING =
  "InstrumentationKey=f68a1d89-fb81-484e-96f2-2e879c6b386c;IngestionEndpoint=https://uaenorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://uaenorth.livediagnostics.monitor.azure.com/;ApplicationId=0e52880c-4b11-4ed3-ba7b-36d61a2c6e46";

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: CONNECTION_STRING,
    // This is an SPA — route changes never trigger a real document load, so the SDK's own
    // auto-tracking (which only fires once, on initial load) would miss every in-app
    // navigation. usePageViewTracking() below tracks each one explicitly instead.
    enableAutoRouteTracking: false,
    autoTrackPageVisitTime: true,
  },
});

appInsights.loadAppInsights();
